import React, {forwardRef} from 'react';
import {Close} from '@mui/icons-material';
import {Alert, type AlertColor, IconButton} from '@mui/material';
import {type CustomContentProps, useSnackbar} from 'notistack';

type NotificationAlertProps = {
  icon?: React.ReactNode;
} & CustomContentProps;

const NotificationAlert = forwardRef<HTMLDivElement, NotificationAlertProps>(
  (props, ref) => {
    const {id, message, variant, icon} = props;
    const {closeSnackbar} = useSnackbar();

    const handleClose = (): void => {
      closeSnackbar(id);
    };

    // Map notistack variant to MUI Alert severity
    const severity = (variant as AlertColor) || 'info';

    return (
      <Alert
        ref={ref}
        variant="filled"
        severity={severity}
        icon={icon}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{p: 0.5}}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        }
      >
        {message}
      </Alert>
    );
  }
);

NotificationAlert.displayName = 'NotificationAlert';

export default NotificationAlert;
